import { render, staticRenderFns } from "./WindowBanner.vue?vue&type=template&id=1b7eddc5&scoped=true&"
import script from "./WindowBanner.vue?vue&type=script&lang=js&"
export * from "./WindowBanner.vue?vue&type=script&lang=js&"
import style0 from "./WindowBanner.vue?vue&type=style&index=0&id=1b7eddc5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7eddc5",
  null
  
)

export default component.exports